import { UseFormReturn } from "react-hook-form";

import { FormatCurrencyFunction } from "@/hooks/useConfig/types";

import {
  MediaConstraintsFormData,
  SpendInputFormData,
} from "../scenario-form/ScenarioFormProvider";
import { MediaConstraint, SpendInput } from "../scenario-form/types";
import { HistoricalSpends } from "../scenario-form/utils/logic";

export interface ChannelOption {
  key: string;
  label: string;
  disabled: boolean;
}

export interface HelperText {
  channel?: string;
  minValue?: string;
  maxValue?: string;
}

export interface BaseConstraintRowProps {
  globalIndex: number;
  availableChannels: ChannelOption[];
  disabled?: boolean;
  currencySymbol: string;
  helperText: HelperText;
  onRemove: () => void;
}

export interface OptimizerConstraintRowProps extends BaseConstraintRowProps {
  constraint: MediaConstraint;
  form: UseFormReturn<MediaConstraintsFormData>;
}

export interface ForecastConstraintRowProps extends BaseConstraintRowProps {
  constraint: SpendInput;
  form: UseFormReturn<SpendInputFormData>;
}

export interface BusinessUnit {
  id: number;
  label: string;
  value: string;
  constraints?: MediaConstraint[];
}

export interface ConstraintChannel {
  isAvailable: boolean;
}

export interface ConstraintNode {
  isAvailable: boolean;
  channels: {
    [channel: string]: ConstraintChannel;
  };
}

export interface ConstraintLayer {
  isAvailable: boolean;
  nodes: {
    [nodeUUID: string]: ConstraintNode;
  };
}

export interface ConstraintMapV2 {
  [layer: string]: ConstraintLayer;
}

export interface SpendConstraintsTableProps {
  selectedUnits: Map<string, { brand: string; category: string; product: string }>;
  historicalSpends: HistoricalSpends;
  form: UseFormReturn<MediaConstraintsFormData>;
  disabled?: boolean;
  currencySymbol: string;
  formatCurrency: FormatCurrencyFunction;
  onRemoveUnit?: (unitId: number) => void;
}

export const ALL_CHANNELS_OPTION = {
  label: "All Channels",
  value: "all",
};
